import { render, staticRenderFns } from "./GalleryItem.vue?vue&type=template&id=4fcde3ca&scoped=true&"
import script from "./GalleryItem.vue?vue&type=script&lang=js&"
export * from "./GalleryItem.vue?vue&type=script&lang=js&"
import style0 from "./GalleryItem.vue?vue&type=style&index=0&id=4fcde3ca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcde3ca",
  null
  
)

export default component.exports